import src from "IMAGE";
export default { src, width: 201, height: 60, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AHA7K/yQRy//nX1z/7Sys/+xsLD/sbCw/7Kxsf+zsrL/AGY3Kf+HQy3/hmpi/5eWlv+amZn/mJaW/5iWlv+Ni4v7PD4pgochK1oAAAAASUVORK5CYII="};
